(function (ws) {
    'use strict';

    ws.views.breadcrumbsView = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'catalog',
        GTM_EVENT_ACTION: 'search',

        events: {
            'keydown [data-event="search"]': 'submitSearchQuery',
            'click .tbl-magnifying': 'triggerSearch',
            'click a.last': 'preventClick'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$searchInput = this.$('.lft-search');
        },

        /**
         * Submits a Search query
         * @param {Object} ev
         */
        submitSearchQuery: function (ev) {
            var searchKeyCode = ev.which || ev.keyCode;
            var enteredValue = ev.currentTarget.value;
            var searchValue = $.trim(enteredValue);

            if (searchKeyCode == 13 && searchValue.length > 0) {
                var value = enteredValue.toLocaleUpperCase();
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, searchValue);

                dataLayerAA.search = {};
                dataLayerAA.search.type = 'catalogue';
                dataLayerAA.search.query = searchValue.toLowerCase();
                _satellite.track('event:search');
                var searchQuery;
                var $form;
                if ($('body').hasClass('page-productCatalogPage')) {
                    searchQuery = value + ':relevance:vendorProducts:' + $('#salesOrgValue').val() + ':productSalesOrgList:' + $('#salesOrgValue').val();
                    var $checkboxes = $('.custom-checkbox');
                    _.each($checkboxes, function(checkbox) {
                        if ($(checkbox).prop('checked') === true && $(checkbox).prop('disabled') !== true) {
                            if ($(checkbox).data('url').search('categories') > 0) {
                                searchQuery = searchQuery + ':categories:' + $(checkbox).val();
                            } else if ($(checkbox).data('url').search('vendor') > 0) {
                                searchQuery = searchQuery + ':vendor:' + $(checkbox).val();
                            } else {
                                searchQuery = searchQuery + ':isIntangible:' + $(checkbox).val();
                            }
                        }
                    });

                    $('#searchQueryVal').val(searchQuery);
                    $('#searchTextVal').val(value);
                    $form = $('#globalSearchFormPLP');
                } else {
                    searchQuery = value + ':relevance:vendorProducts:' + $('#salesOrgValue').val() + ':productSalesOrgList:' + $('#salesOrgValue').val();
                    $('#searchQueryValOtherPage').val(searchQuery);
                    $('#searchTextValue').val(value);
                    $form = $('#globalSearchForm');
                }

                $form.submit();
            }
        },

        /**
         * Trigger Search
         */
        triggerSearch: function () {
            var e = $.Event('keydown', {which: 13});
            this.$searchInput.trigger(e);
        },

        /**
         * Prevent last breadcrumb from being clicked
         * @param {event} e
         */
        preventClick: function(e) {
            e.preventDefault();
        }

    });
})(westcon);
